module.exports = __webpack_public_path__ + "static/banner-two-shape12-7f345df12d86db41675b1290bccdc9b6.png";